// Do not used `omit-deep` package because it convert undefined to {} which is wrong
// when we updateWebinar with endDate = never

import { stripTypename } from '@apollo/client/utilities';
export default stripTypename;
